import { booleanColumn } from '@/shared/grids/columns/booleanColumn';
import { dateColumn } from '@/shared/grids/columns/dateColumn';
import { idColumn } from '@/shared/grids/columns/idColumn';
import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridSettings } from '@/shared/types/grid';

import { ServiceView } from '@prisma/client';

export const serviceGrid: GridSettings<ServiceView> = {
  defaultSort: {
    name: 'asc',
  },
  columns: [
    idColumn(),
    textColumn({
      header: 'Service',
      field: 'name',
    }),
    booleanColumn({
      header: 'Show Tab in Tasks',
      field: 'showInNav',
    }),
    dateColumn({
      header: 'Archived',
      field: 'archivedTime',
      visible: false,
    }),
  ],
};
